if (!customElements.get('rwc-grid-signup')) {
  customElements.define('rwc-grid-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const form = this.querySelector('form');
      const button = form.querySelector('button');
      const status = this.querySelector('[data-status]');
      const success = this.querySelector('.rwc-grid__success');
      button.disabled = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        button.disabled = true;
        status.textContent = status.dataset.pending;
        const timeout = new AbortController();
        const timer = setTimeout(() => timeout.abort(), 15000);
        this.request = timeout;
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.company), {
            method: 'POST',
            headers: {'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15'},
            signal: timeout.signal,
            body: JSON.stringify({data: {
              type: 'subscription',
              attributes: {custom_source: 'RWC Join the Grid website signup', profile: {data: {
                type: 'profile',
                attributes: {email: form.elements.email.value.trim(), properties: {'RWC Signup Source': 'Join the grid', 'RWC Welcome Code': 'GRID10'}, subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}}
              }}},
              relationships: {list: {data: {type: 'list', id: this.dataset.list}}}
            }})
          });
          if (response.status !== 202) throw new Error('Subscription was not accepted');
          form.hidden = true;
          success.hidden = false;
          success.focus();
        } catch {
          if (this.isConnected) {
            status.textContent = status.dataset.error;
            button.disabled = false;
          }
        } finally {
          clearTimeout(timer);
          this.request = null;
        }
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      this.controller = null;
    }
  });
}
